import { render, staticRenderFns } from "./descansos.vue?vue&type=template&id=18400040&scoped=true&"
import script from "./descansos.vue?vue&type=script&lang=js&"
export * from "./descansos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18400040",
  null
  
)

export default component.exports